import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
	Table,
	Button,
	Modal,
	Form,
	Row,
	Col,
	Space,
	Select,
	Card,
	notification,
	Badge,
	Spin,
	DatePicker,
	Input,
} from "antd";
import {
	UsergroupAddOutlined,
	EditOutlined,
	EyeOutlined,
} from "@ant-design/icons";
import teamGroupService from "../../services/teamGroup";
import formService from "../../services/form";
import taskService from "../../services/tasks";
import DefaultLayout from "../../components/layout/DefaultLayout";
import Header from "../../components/header";
import { useSelector } from "react-redux";
import UserComponent from "./../../components/user";
import dayjs from "dayjs";

const { Option } = Select;

const Tasks = () => {
	const dateFormat = "YYYY-MM-DD HH:mm:ss";

	const [isModalVisible, setIsModalVisible] = useState(false);
	const [edit, setEdit] = useState(null);
	const [form] = Form.useForm();
	const [searchForm] = Form.useForm();

	const [formNames, setformNames] = useState([]);
	const [tasks, setTasks] = useState([]);
	const [taskLists, setTaskLists] = useState([]);

	const [teamGroups, setTeamGroups] = useState([]);
	const [groupTeamMembers, setGroupTeamMembers] = useState([]);
	const [loading, setLoading] = useState(true);
	const [formId, setFormId] = useState(0);

	const [currentPage, setCurrentPage] = useState(1);
	const [totalDataCount, setTotalDataCount] = useState(0);
	const [itemsPerPage, setItemsPerPage] = useState(15);

	const [taskData, setTaskData] = useState([
		{
			forms: undefined,
			key: undefined,
			team_ids: undefined,
			member: undefined,
		},
	]);

	const { currentUser } = useSelector((state) => state.user);

	const permissions = currentUser?.["roles.permission"] || [];
	const haveAddPermission = permissions.some(
		(permission) => permission.name === "AssignTask-create"
	);
	const haveEditPermission = permissions.some(
		(permission) => permission.name === "AssignTask-edit"
	);

	const columns = [
		{
			title: "Sequence No",
			dataIndex: "sequence_no",
			key: "sequence_no",
			width: 250,
			sorter: (a, b) => a.sequence_no.localeCompare(b.sequence_no),
		},
		{
			title: "Task Name",
			dataIndex: "task_name",
			key: "task_name",
			width: 350,
			sorter: (a, b) => a.task_name.localeCompare(b.task_name),
		},
		{
			title: "Task Status",
			dataIndex: ["task_status", "name"],
			key: "name",
			width: 130,
			sorter: (a, b) =>
				a.task_status?.name?.localeCompare(b.task_status?.name || "") || 0,
			render: (status) => status || "Open", // Default to 'Open' if no status
		},
		{
			title: "Teams",
			dataIndex: "assigned_task_team",
			key: "assigned_task_team",
			width: 450,
			render: (assignedTaskTeams) => (
				<div>
					{assignedTaskTeams.map((team, index) => (
						<div key={`team-${index}`} style={{ marginBottom: 8 }}>
							<strong>{team.team.name}</strong>
							<div style={{ marginLeft: 16 }}>
								<div>
									<strong>Managers:</strong>
									{Array.isArray(team.managers)
										? team.managers.map((m) => m.name).join(", ")
										: Object.values(team.managers || {})
												.map((m) => m.name)
												.join(", ")}
								</div>
								<div>
									<strong>Members:</strong>
									{team.members.map((member) => member.name).join(", ")}
								</div>
								{team.start_at && (
									<div>
										<strong>Start:</strong> {team.start_at}
									</div>
								)}
								{team.due_at && (
									<div>
										<strong>Due:</strong> {team.due_at}
									</div>
								)}
								{team.task_status_name && (
									<div>
										<strong>Status:</strong> {team.task_status_name.name}
									</div>
								)}
							</div>
						</div>
					))}
				</div>
			),
		},
		{
			title: "Actions",
			key: "actions",
			fixed: "right",
			width: 100,
			render: (text, record) => (
				<>
					<Link to={record.url} style={{ marginRight: "5px" }}>
						<EyeOutlined />
					</Link>

					{haveEditPermission && (
						<Space>
							<Link
								onClick={() => handleEdit(record)}
								style={{ cursor: "pointer" }}
								className='mr-3'
							>
								<EditOutlined />
							</Link>
						</Space>
					)}
				</>
			),
		},
	];

	const [sortField, setSortField] = useState("");
	const [sortOrder, setSortOrder] = useState("");

	const getTasks = async (
		page = 1,
		itemsPerPage = 10,
		sortBy = "",
		order = "",
		filters = {}
	) => {
		setLoading(true);
		try {
			const response = await taskService.getTasks(
				page,
				itemsPerPage,
				sortBy,
				order,
				filters
			);
			setTaskLists(response.data);
			setTotalDataCount(response.meta.total);
			setCurrentPage(response.meta.current_page);
			setItemsPerPage(response.meta.per_page || itemsPerPage);
		} catch (error) {
			console.error("Error fetching tasks:", error);
		} finally {
			setLoading(false);
		}
	};

	// const getTasks = async (
	// 	page = 1,
	// 	itemsPerPage = 10,
	// 	sortBy = "",
	// 	order = ""
	// ) => {
	// 	setLoading(true);
	// 	try {
	// 		const response = await taskService.getTasks(
	// 			page,
	// 			itemsPerPage,
	// 			sortBy,
	// 			order
	// 		);
	// 		setTaskLists(response.data);
	// 		setTotalDataCount(response.meta.total);
	// 		setCurrentPage(response.meta.current_page);
	// 		setItemsPerPage(response.meta.per_page || itemsPerPage);
	// 	} catch (error) {
	// 		console.error("Error fetching tasks:", error);
	// 	} finally {
	// 		setLoading(false);
	// 	}
	// };

	const onSearch = async (values) => {
		const filters = {
			search: values.search || "",
			manager_id: values.manager_id || "",
			member_id: values.member_id || "",
		};

		await getTasks(1, itemsPerPage, "", "", filters);
	};

	const getForms = async () => {
		try {
			const forms = await formService.getAllForms();
			setformNames(forms);
		} catch (error) {
			console.error("Error getting forms:", error);
			return [];
		}
	};

	const getServiceDeskAllTask = async (id) => {
		try {
			const response = await formService.getServiceDeskAllTask(id);
			setFormId(id);
			setTasks(response.data);
		} catch (error) {}
	};

	const getFormGroup = async (id) => {
		//console.log(id)
		try {
			const response = await teamGroupService.getFormGroup(id);
			//console.log(response);
			setTeamGroups(response);
		} catch (error) {}
	};

	const getGroupTeamMembers = async (id) => {
		setLoading(true);
		let recordId = typeof id === "object" ? id.value : id;
		try {
			const response = await teamGroupService.getGroupTeamMembers(recordId);
			setLoading(false);
			console.log(response);
			setGroupTeamMembers(response);
		} catch (error) {}
	};

	useEffect(() => {
		getForms();
		getTasks();
	}, []);

	const showModal = () => {
		setIsModalVisible(true);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
		setEdit(null);
		form.resetFields();
	};

	const handleEdit = async (record) => {
		console.log("record1,", record);
		setLoading(true);
		setEdit(record);
		setIsModalVisible(true);

		const selectedTaskData = record.assigned_task_team.map((team) => ({
			team_id: team.team.id,
			team_members: team.members.map((member) => member.id),
		}));

		setTaskData(selectedTaskData);

		try {
			await Promise.all([getFormGroup(record.form.id)]);

			setLoading(false);
			record.assigned_task_team.forEach((team) => {
				getGroupTeamMembers(team.team.id);
			});

			getServiceDeskAllTask(record.form?.id);
			console.log("record3,", record);

			const initialValues = {
				form_id: record.form?.id,
				key: record.key_entry,
				start_at: dayjs(record.start_at, "DD-MM-YYYY HH:mm:ss").isValid()
					? dayjs(record.start_at, "DD-MM-YYYY HH:mm:ss")
					: null,
				due_at: dayjs(record.due_at, "DD-MM-YYYY HH:mm:ss").isValid()
					? dayjs(record.due_at, "DD-MM-YYYY HH:mm:ss")
					: null,
				team_ids: record.assigned_task_team.map((team) => ({
					id: team.team.id,
					team_id: team.team.id,
					team_members: team.members.map((member) => member.id),
				})),
			};

			form.setFieldsValue(initialValues);
		} catch (error) {
			console.error("Error fetching forms and tasks:", error);
		}
	};

	const onFinish = async (values) => {
		console.log("values,", values);
		setLoading(true);
		const formattedValues = {
			...values,
			start_at: values.start_at?.format("YYYY-MM-DD HH:mm:ss"),
			due_at: values.due_at?.format("YYYY-MM-DD HH:mm:ss"),
		};
		try {
			if (edit) {
				//console.log('edit')
				const response = await taskService.updateTask(edit.id, formattedValues);
				console.log(response);
				if (response.success) {
					notification.success({
						message: "Task Updated",
						description: "Task Updated Successfully",
					});

					setEdit(null);
					form.resetFields();
				}
			} else {
				//console.log('post')
				const response = await taskService.postTask(formattedValues);
				//console.log(response)
				if (response.success) {
					notification.success({
						message: "Task Added",
						description: "Task Added Successfully",
					});
				}
			}
			setIsModalVisible(false);
			getTasks(currentPage);
		} catch (error) {
			console.log(error);
			notification.error({
				message: "Error",
				description: error.response.data.message,
			});
		} finally {
			setLoading(false);
		}
	};

	const removeManagerGroup = (index) => {
		setTaskData((prevData) => prevData.filter((_, i) => i !== index));
	};

	const renderTaskDetails = () => {
		return taskData.map((data, index) => (
			<div key={`task-${index}`}>
				<Card
					size='small'
					title={
						<span>
							<Badge color='#2d77fa' count={index + 1} /> Task Details
						</span>
					}
					className='mb-10'
				>
					<Row gutter={[12, 12]}>
						<Col span={24}>
							<Form.Item
								name={["team_ids", index, "team_id"]}
								label={`Team Groups`}
								rules={[
									{ required: true, message: "Please select Team Group" },
								]}
							>
								<Select
									showSearch={true}
									optionFilterProp='children'
									style={{ width: "100%" }}
									size='large'
									onChange={(data) => {
										getGroupTeamMembers(data);
										form.setFieldsValue({
											["team_ids"]: {
												[index]: { ["team_members"]: undefined },
											},
										});
									}}
								>
									{teamGroups &&
										teamGroups.map((group, index) => (
											<Option key={group.id} value={group.id}>
												{group.name}
											</Option>
										))}
								</Select>
							</Form.Item>
						</Col>

						<Col span={24}>
							<Form.Item
								name={["team_ids", index, "team_members"]}
								label={`Team Members`}
								rules={[
									{ required: true, message: "Please select Team Members" },
								]}
							>
								<Select
									mode='multiple'
									showSearch={true}
									optionFilterProp='children'
									style={{ width: "100%" }}
									size='large'
								>
									{groupTeamMembers &&
										groupTeamMembers.members?.map((member, index) => (
											<Option key={member.id} value={member.id}>
												{member.name} - {member.email}
											</Option>
										))}
								</Select>
							</Form.Item>
						</Col>
					</Row>
				</Card>
				{index > 0 && (
					<div className='textRight mb-10'>
						<Button type='dashed' onClick={() => removeManagerGroup(index)}>
							Remove
						</Button>
					</div>
				)}
			</div>
		));
	};

	const handleAddManager = () => {
		setTaskData((prevData) => [
			...prevData,
			{
				forms: undefined,
				key: undefined,
				team_ids: undefined,
				member: undefined,
			},
		]);
	};

	const handleAddManagerForNewRecord = () => {
		setTaskData((prevData) => [
			{
				forms: undefined,
				key: undefined,
				team_ids: undefined,
				member: undefined,
			},
		]);
	};

	return (
		<DefaultLayout>
			<Row gutter={[24, 24]}>
				<Col span={24}>
					<Header
						icon={<UsergroupAddOutlined />}
						title='Assign Task'
						right={
							haveAddPermission ? (
								<Button
									className='btn-blue'
									type='primary'
									onClick={() => {
										showModal();
										handleAddManagerForNewRecord();
									}}
								>
									Add Task
								</Button>
							) : null
						}
					/>
				</Col>
			</Row>

			<Row gutter={[24, 24]}>
				<Col span={24}>
					<Card>
						<Form form={searchForm} onFinish={onSearch} layout='vertical'>
							<Card className='pt-6' style={{ paddingBottom: "0 !important" }}>
								<Row gutter={[12, 12]}>
									<Col lg={8} md={8} sm={8} xs={12}>
										<Form.Item name='search' label='Search'>
											<Input size='large' placeholder='Search Text' />
										</Form.Item>
									</Col>

									<Col lg={4} md={5} sm={6} xs={12}>
										<Form.Item name='manager_id' label='Select Manager'>
											<UserComponent />
										</Form.Item>
									</Col>

									<Col lg={4} md={5} sm={6} xs={12}>
										<Form.Item name='member_id' label='Select Member'>
											<UserComponent />
										</Form.Item>
									</Col>

									<Col
										lg={4}
										md={5}
										sm={6}
										xs={12}
										className='d-flex align-items-center'
									>
										<p>&nbsp;</p>
										<Button
											block
											className='btn-blue'
											htmlType='submit'
											type='primary'
											size='large'
										>
											Search
										</Button>
									</Col>
								</Row>
							</Card>
						</Form>
					</Card>
				</Col>
			</Row>

			<Card>
				<Table
					scroll={{ x: 1200 }}
					sticky={true}
					style={{ minHeight: "100vh" }}
					loading={loading}
					columns={columns}
					dataSource={taskLists.map((item) => ({ ...item, key: item.id }))}
					onChange={(pagination, filters, sorter) => {
						let order = "";
						if (sorter.order === "ascend") order = "asc";
						else if (sorter.order === "descend") order = "desc";
						else order = "";
						setSortField(sorter.field || "");
						setSortOrder(order);
						getTasks(
							pagination.current,
							pagination.pageSize,
							sorter.field || "",
							order
						);
					}}
					pagination={{
						total: totalDataCount,
						current: currentPage,
						pageSize: itemsPerPage,
						showSizeChanger: true,
						pageSizeOptions: ["5", "10", "15", "20", "50"],
						onChange: (page, pageSize) =>
							getTasks(page, pageSize, sortField, sortOrder),
						showTotal: (total, range) =>
							`${range[0]}-${range[1]} of ${total} items`,
					}}
				/>
			</Card>

			<Modal
				style={{ top: 14 }}
				title={edit ? "Edit Manager" : "Add Task"}
				open={isModalVisible}
				onCancel={handleCancel}
				footer={null}
				width={900}
			>
				<Form
					form={form}
					onFinish={onFinish}
					layout='vertical'
					className='mt-20'
				>
					{/* {!edit && ( */}
					<Row gutter={[12, 12]}>
						<Col span={12}>
							<Form.Item
								name={"form_id"}
								label={`Form`}
								rules={[{ required: true, message: "Please select Form" }]}
							>
								<Select
									showSearch={true}
									optionFilterProp='children'
									style={{ width: "100%" }}
									size='large'
									onChange={(value) => {
										form.resetFields(["key", "team_ids"]);
										getServiceDeskAllTask(value);
									}}
								>
									{formNames &&
										formNames.map((formName) => (
											<Option key={formName.id} value={formName.id}>
												{formName.name}
											</Option>
										))}
								</Select>
							</Form.Item>
						</Col>

						<Col span={12}>
							<Form.Item
								name={"key"}
								label={`Select Task`}
								rules={[{ required: true, message: "Please select Task" }]}
							>
								<Select
									showSearch={true}
									optionFilterProp='children'
									style={{ width: "100%" }}
									size='large'
									onChange={() => {
										getFormGroup(formId);
									}}
								>
									{tasks &&
										tasks.map((task) => (
											<Option key={task.id} value={task.id}>
												{task.request_title}
											</Option>
										))}
								</Select>
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item
								label='Start At'
								name='start_at'
								rules={[
									{
										required: true,
										message: "Please select start date & time",
									},
								]}
							>
								<DatePicker
									showTime
									format={dateFormat}
									style={{ width: "100%" }}
									size='large'
								/>
							</Form.Item>
						</Col>

						{/* Due At */}
						<Col span={12}>
							<Form.Item
								label='Due At'
								name='due_at'
								rules={[
									{ required: true, message: "Please select due date & time" },
								]}
							>
								<DatePicker
									showTime
									format={dateFormat}
									style={{ width: "100%" }}
									size='large'
								/>
							</Form.Item>
						</Col>
					</Row>

					{/*  )} */}

					<Spin spinning={loading}>{renderTaskDetails()}</Spin>

					<div
						style={{ display: "flex", justifyContent: "space-between" }}
						className='mb-20'
					>
						<Button type='dashed' onClick={handleAddManager}>
							Add More
						</Button>
					</div>

					<Form.Item>
						<Button type='primary' htmlType='submit' loading={loading}>
							{edit ? "Save Changes" : "Add Task"}
						</Button>
					</Form.Item>
				</Form>
			</Modal>
		</DefaultLayout>
	);
};

export default Tasks;
